import type { IconDefaultProps } from './types'

const CloseIconBold = ({ className }: IconDefaultProps): JSX.Element => (
  <svg
    className={className}
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M10.2031 8L15.2656 13.0625C15.5469 13.3438 15.5469 13.8594 15.2656 14.1406L14.0938 15.3125C13.8125 15.5938 13.2969 15.5938 13.0156 15.3125L8 10.25L2.9375 15.3125C2.65625 15.5938 2.14062 15.5938 1.85938 15.3125L0.6875 14.1406C0.40625 13.8594 0.40625 13.3438 0.6875 13.0625L5.75 8L0.6875 2.98438C0.40625 2.70312 0.40625 2.1875 0.6875 1.90625L1.85938 0.734375C2.14062 0.453125 2.65625 0.453125 2.9375 0.734375L8 5.79688L13.0156 0.734375C13.2969 0.453125 13.8125 0.453125 14.0938 0.734375L15.2656 1.90625C15.5469 2.1875 15.5469 2.70312 15.2656 2.98438L10.2031 8Z'
      fill='currentColor'
      fillRule='evenodd'
      clipRule='evenodd'
    />
  </svg>
)

export default CloseIconBold
